import React, { useState } from "react";
import styles from "./collapsed_container.module.css";

const SimpleCollapsedContainer = ({
  children, label, labelValue = null
}) => {

  const [showContent, setShowContent] = useState(false);

  return (
    <div className={`${styles.container} ${!showContent && styles.container__collapsed}`}>
      <div className={styles.subtitle_button_container}>
        <p className={`subSubtitle subSubtitle__left ${styles.subtitle}`} onClick={() => setShowContent(!showContent)}>
          {label}
          {labelValue && <span className="text">{`: ${labelValue}`}</span>}
        </p>
        <div className="button_container_horizontal">
          <button
            className={`button_empty_square ${showContent ? 'arrow_up_white' : 'arrow_down_white'}`}
            onClick={() => setShowContent(!showContent)}
          />
        </div>

      </div>
      {showContent && <br />}
      {showContent && children}
    </div>
  );
};

export default SimpleCollapsedContainer;
